<template>
  <article class>
    <transition name="fade">
      <Overlay @on-click="$emit('close-modal')" />
    </transition>
    <transition
      name="fade"
    >
    <div class="fixed bottom-0 transform w-full z-20 slide-up-half left-0 right-0">
      <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
      <slot></slot>
    </div>
  </transition>
  </article>
</template>
<script>
import Overlay from './Overlay.vue';

export default {
  name: 'Modal',
  components: { Overlay },
};
</script>
<style lang='scss' scoped>
.slide-up-half-enter-active,
.slide-up-half-leave-active {
  transition: transform 0.2s ease;
}

.slide-up-half-enter-from,
.slide-up-half-leave-to {
  transform: translateY(100%);
  transition: all 150ms ease-in 0s;
}
</style>
